<template>
  <div class='core'>
    <div class='layui-fluid repair-statistics-tabs'>
      <div class="layui-form layui-card-header layuiadmin-card-header-auto">
        <div class="layui-inline"><label class="layui-search-label">时间段:</label></div>
        <div class="layui-inline">
          <div class="block">
            <el-date-picker
              size="small"
              type="daterange"
              @change="dateRangeChange"
              v-model="dateValue"
              value-format='yyyy-MM-dd'
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <button class="layui-btn layuiadmin-btn-list" title="查询" @click="queryRepairStatisticsOnClick()">查 询</button>
      </div>

      <el-tabs v-model="activeTabName" @tab-click="handleClick" type="border-card">
        <el-tab-pane label="故障总表" name="first" v-loading="loading">
          <totalStatistics
            @queryRepairTotalStatisticsList="queryRepairTotalStatisticsList"
            :totalStatisticsList="totalStatisticsList"
            :rowCount="rowCount"
            :beginDate="beginDate"
            :endDate="endDate"
          />
        </el-tab-pane>
        <el-tab-pane label="故障明细统计表" name="second" v-loading="loading">
          <detailStatistics
            @queryRepairDetailStatisticsList="queryRepairDetailStatisticsList"
            :detailStatisticsList="detailStatisticsList"
            :rowCount="rowCount"
            :beginDate="beginDate"
            :endDate="endDate"
          />
        </el-tab-pane>
        <el-tab-pane label="故障总数排序统计表" name="third" v-loading="loading">
          <totalSortStatistics
            @queryRepairTotalSortStatisticsList="queryRepairTotalSortStatisticsList"
            :totalSortStatisticsList="totalSortStatisticsList"
            :rowCount="rowCount"
            :beginDate="beginDate"
            :endDate="endDate"
          />
        </el-tab-pane>
        <el-tab-pane label="统计图表" name="fourth">
          <statisticsCharts
            :monthRepairVOList="monthRepairVOList"
            :repairStatisticsChartPieHelpVOList="repairStatisticsChartPieHelpVOList"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>

import "../../../utils/map/css/core.css"
import lineStatistics from './lineStatistics'
import totalStatistics from './totalStatistics'
import detailStatistics from './detailStatistics'
import totalSortStatistics from './totalSortStatistics'
import statisticsCharts from "@/components/repairs/repairStatistics/statisticsCharts";
import request from "@/network/networkconfig";

export default {
  name: 'repairStatisticsManage',
  components: {
    lineStatistics,
    totalStatistics,
    detailStatistics,
    totalSortStatistics,
    statisticsCharts
  },
  data () {
    return {
      activeTabName: 'first',
      totalSortStatisticsList: [],
      totalStatisticsList: [],
      detailStatisticsList: [],
      monthRepairVOList: [],
      repairStatisticsChartPieHelpVOList: [],
      beginDate: "",
      endDate: "",
      tabIndex: "0",
      dateValue: "",
      pageIndex: 0,
      pageSize: 10,
      rowCount: 0,
      loading: true
    }
  },
  mounted(){
    let beginDate = this.beginDate;
    let endDate = this.endDate;

    this.queryRepairTotalStatisticsList(beginDate, endDate, this.pageIndex, this.pageSize);
  },
  methods: {
    handleClick(tab, event) {
      // 每次切换tab，把日期置空，分页置空
      this.beginDate = "";
      this.endDate = "";
      this.dateValue = "";
      this.pageIndex = 0;
      this.pageSize = 10;
      this.rowCount = 0;

      if (tab.index === '0') {
        this.queryRepairTotalStatisticsList(this.beginDate, this.endDate, this.pageIndex, this.pageSize);
      } else if (tab.index === '1') {
        this.queryRepairDetailStatisticsList(this.beginDate, this.endDate, this.pageIndex, this.pageSize);
      } else if (tab.index === '2') {
        this.queryRepairTotalSortStatisticsList(this.beginDate, this.endDate, this.pageIndex, this.pageSize);
      } else if (tab.index === '3') {
        this.queryRepairStatisticsChartData();
      }

      this.tabIndex = tab.index;
    },

    // 故障总表
    queryRepairTotalStatisticsList(beginDate, endDate, pageIndex, pageSize) {
      if (!beginDate && !endDate) {
        beginDate = this.beginDate
        endDate = this.endDate
      }

      if (!pageIndex && !pageSize) {
        pageIndex = this.pageIndex
        pageSize = this.pageSize
      }

      this.loading = true

      request({
        url: "/yw/repairStatistics/queryRepairTotalStatisticsList",
        method: 'post',
        params: {beginDate: beginDate, endDate: endDate, pageIndex: pageIndex, pageSize: pageSize }
      }).then(result => {
        if (result.result.errorMsg) {
          this.layer.openAlert(result.result.errorMsg)
        } else {
          this.totalStatisticsList = result.result
          this.rowCount = result.rowCount
          this.loading = false
        }
      }, null, { targetEl : $('body')})
    },

    //故障明细统计表
    queryRepairDetailStatisticsList(beginDate, endDate, pageIndex, pageSize) {
      if (!beginDate && !endDate) {
        beginDate = this.beginDate
        endDate = this.endDate
      }

      if (!pageIndex && !pageSize) {
        pageIndex = this.pageIndex
        pageSize = this.pageSize
      }

      this.loading = true

      request({
        url: '/yw/repairStatistics/queryRepairDetailStatisticsList',
        method: 'post',
        params: {beginDate: beginDate, endDate: endDate, pageIndex: pageIndex, pageSize: pageSize}
      }).then(result => {
        if (result.result.errorMsg) {
          this.layer.openAlert(result.result.errorMsg)
        } else {
          this.detailStatisticsList = result.result
          this.rowCount = result.rowCount
          this.loading = false
        }
      }, null, { targetEl : $('body')})
    },

    //故障总数排序统计表
    queryRepairTotalSortStatisticsList(beginDate, endDate, pageIndex, pageSize) {
      if (!beginDate && !endDate) {
        beginDate = this.beginDate
        endDate = this.endDate
      }

      if (!pageIndex && !pageSize) {
        pageIndex = this.pageIndex
        pageSize = this.pageSize
      }

      this.loading = true

      request({
        url: '/yw/repairStatistics/queryRepairTotalSortStatisticsList',
        method: 'post',
        params: {beginDate: beginDate, endDate: endDate, pageIndex: pageIndex, pageSize: pageSize}
      }).then(result => {
        if (result.result.errorMsg) {
          this.layer.openAlert(result.result.errorMsg)
        } else {
          this.totalSortStatisticsList = result.result
          this.rowCount = result.rowCount
          this.loading = false
        }
      }, null, { targetEl : $('body')})
    },

    // 折线图  扇形图
    queryRepairStatisticsChartData() {
      request({
        url: "/yw/repairStatistics/queryRepairStatisticsChartData",
        method: 'post',
      }).then(result => {
        if (result.result.errorMsg) {
          this.layer.openAlert(result.result.errorMsg)
        } else {
          this.monthRepairVOList = result.result.monthRepairVOList
          this.repairStatisticsChartPieHelpVOList = result.result.repairStatisticsChartPieHelpVOList
        }
      }, null, { targetEl : $('body')})
    },

    dateRangeChange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        this.beginDate = dateRange[0]
        this.endDate = dateRange[1]
      } else if (!dateRange) {
        this.beginDate = ''
        this.endDate = ''
      }
    },

    queryRepairStatisticsOnClick() {
      let tabIndex = this.tabIndex;
      let beginDate = this.beginDate;
      let endDate = this.endDate;

      if (tabIndex === '0') {
        this.queryRepairTotalStatisticsList(beginDate, endDate, this.pageIndex, this.pageSize);
      } else if (tabIndex === '1') {
        this.queryRepairDetailStatisticsList(beginDate, endDate, this.pageIndex, this.pageSize);
      } else if (tabIndex === '2') {
        this.queryRepairTotalSortStatisticsList(beginDate, endDate, this.pageIndex, this.pageSize);
      }
    },




  }
}
</script>

<style scoped>


</style>




// WEBPACK FOOTER //
// src/components/repairs/repairStatistics/index.vue